import React from "react";
import LoadingIndicator from "../../presentational/LoadingIndicator";
import { useTurnstile } from "../../../hooks/useTurnstile";
import './RegistrationCheck.css';

interface RegistrationCheckParameters {
  serverError: string;
}

const RegistrationCheck: React.FC<RegistrationCheckParameters> = ({
  serverError,
}) => {
  useTurnstile();

  return (
  <form className="login-action registration-check">
    {
      serverError && (
        <p className="server-error">{serverError}</p>
      )
    }
    <div className="turnstile-container">
      <div id="cf-turnstile" className="cf-turnstile"></div>
      <LoadingIndicator loadingText="" />
    </div>
  </form>
  )
}

export default RegistrationCheck
